import { useMemo } from 'react';
import { PROGRESSIONS, Progression, ProgressionMood, ProgressionGenre } from '../data/progressions';
import { Key } from '../data/keys';

interface UseProgressionsOptions {
  key: Key | null;
  moods?: ProgressionMood[];
  genres?: ProgressionGenre[];
}

export function useProgressions({ key, moods = [], genres = [] }: UseProgressionsOptions): Progression[] {
  return useMemo(() => {
    if (!key) return [];

    return PROGRESSIONS.filter(p => {
      if (!p.modes.includes(key.mode)) return false;
      if (moods.length > 0 && !moods.some(m => p.mood.includes(m))) return false;
      if (genres.length > 0 && !genres.some(g => p.genre.includes(g))) return false;
      return true;
    });
  }, [key, moods, genres]);
}
